import { StoreTranslationsDateField } from 'app/models/types/store/translations';

export const fetchDatesTranslations = async (
  locale: string,
): Promise<StoreTranslationsDateField> => {
  return fetch(`${process.env.SEARCH_PUBLIC_URL}dates/${locale}.json`).then((res) => res.json());
};
